var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPasportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 26,
    viewBox: "0 0 23 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_133)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.0996 18.7H4.79961C4.39961 18.7 4.09961 19 4.09961 19.4C4.09961 19.8 4.39961 20.1 4.79961 20.1H17.0996C17.4996 20.1 17.7996 19.8 17.7996 19.4C17.8996 19 17.5996 18.7 17.0996 18.7Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.6996 21.8H7.29961C6.89961 21.8 6.59961 22.1 6.59961 22.5C6.59961 22.9 6.89961 23.2 7.29961 23.2H14.6996C15.0996 23.2 15.3996 22.9 15.3996 22.5C15.3996 22.1 15.0996 21.8 14.6996 21.8Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2008 3.20001C7.40078 3.20001 4.30078 6.30001 4.30078 10.1C4.30078 13.9 7.40078 17 11.2008 17C15.0008 17 18.1008 13.9 18.1008 10.1C18.1008 6.30001 14.9008 3.20001 11.2008 3.20001ZM5.80078 9.30001C6.10078 7.50001 7.20078 5.90001 8.80078 5.20001C8.40078 6.30001 8.10078 7.80001 8.00078 9.30001H5.80078ZM9.50078 9.30001C9.60078 6.50001 10.6008 4.60001 11.2008 4.60001C11.8008 4.60001 12.7008 6.40001 12.9008 9.30001H9.50078ZM8.90078 14.9C7.30078 14.1 6.10078 12.6 5.90078 10.8H8.00078C8.10078 12.4 8.40078 13.9 8.90078 14.9ZM12.8008 10.8C12.7008 13.6 11.7008 15.5 11.1008 15.5C10.5008 15.5 9.60078 13.7 9.40078 10.8H12.8008ZM16.5008 10.8C16.2008 12.6 15.1008 14.2 13.5008 14.9C14.0008 13.8 14.3008 12.3 14.4008 10.8H16.5008ZM16.5008 9.30001H14.4008C14.3008 7.70001 14.0008 6.30001 13.5008 5.20001C15.1008 6.00001 16.2008 7.50001 16.5008 9.30001Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.7 0H18.5H17.3H7.1H2.4H2.3C1 0.1 0 1.2 0 2.6V23.4C0 24.8 1.2 26 2.6 26H19.8C21.2 26 22.4 24.8 22.4 23.4V2.6C22.3 1.2 21.2 0 19.7 0ZM20.8 2.6V23.4C20.8 24 20.3 24.5 19.7 24.5H2.6C2 24.5 1.5 24 1.5 23.4V2.6C1.5 2 2 1.5 2.6 1.5H19.8C20.3 1.5 20.8 2 20.8 2.6Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_133"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22.3,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPasportIcon);
export default __webpack_public_path__ + "static/media/pasport_icon.ac3292e830411737046f7f2bbe2d5372.svg";
export { ForwardRef as ReactComponent };